export default "__VITE_ASSET__qGN2BhMi__"